import React from "react";
import { formatDate } from "utils/dateUtil";

const AppointmentItem = ({ arrow, next, onClick, project, checked }) => {
const formattedDate = project?.date ? formatDate(project.date).formattedDate : "";

  const itemNames =
    project?.orderItems?.map((oi) => oi?.project?.name).filter(Boolean) ?? [];

  let trainingTitle = "";
  if (itemNames.length > 1) {
    trainingTitle = `${itemNames[0]}, ...`;
  } else if (itemNames.length === 1) {
    trainingTitle = itemNames[0];
  } else {
    const trainerFull = `${project?.trainer?.firstName ?? ""} ${project?.trainer?.lastName ?? ""}`.trim();
    trainingTitle = project?.project?.name || "Schulung" ||trainerFull;
  }

  return (
    <div      
      className={`appointment-next-card${checked ? " appointment-next-card--checked" : ""}`}
      onClick={onClick}
    >
      <div className="appointment-next-card-text">
        {formattedDate && <div className="appointment-next-card-date">{formattedDate}</div>}
        <div className="appointment-next-card-title">{trainingTitle}</div>
      </div>
      {arrow && (
        <div className="appointment-arrow">
          <img src={arrow} alt="arrow" class="appointment-project-arrow" />
        </div>
      )}
    </div>
  );
};

export default AppointmentItem;
